import { useEffect } from 'react';
import { useEffectOnce } from 'react-use';

const useMemoScrollPosition = (loading: boolean) => {
  useEffectOnce(() => {
    // memorise the scroll position
    // this is for when the user navigate to jdp and back
    // we can bring them back to this scroll position
    const memoScroll = () => {
      const doc = document.documentElement;
      const scrollLeft =
        (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      const scrollTop =
        (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      window.history.replaceState({ scrollLeft, scrollTop }, '');
    };
    window.addEventListener('unload', memoScroll);
    return () => window.removeEventListener('unload', memoScroll);
  });

  useEffect(() => {
    const { scrollLeft = 0, scrollTop = 0 } = window.history.state || {};
    window.scrollTo(scrollLeft, scrollTop);
  }, [loading]);
};

export { useMemoScrollPosition };
